import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { handleUnitSelection } from '../../store/slices/settings/unitsSlice';
import {
  getUserProfileDataService,
  updateUserProfileService,
} from '../../../services/userProfile.service';
import { logger } from '../../../helpers/logger';
import { describeProfileSaveError } from '../../../helpers/userProfile';
import { unitsPayload } from '../../../helpers/payloads/settingsPayloads';
import { settingsMessage } from './settingsMessage';

export const unitsMessage = (message) =>
  settingsMessage(
    'units of measurement',
    'change of option',
    message || 'settings have been applied',
  );

/** The units panel: the °F/°C toggle (0 is °F) and saving it. */
export const useSaveUnits = () => {
  const dispatch = useDispatch();
  const [metricImperialToggle, setMetricImperialToggle] = useState(null);

  const save = async () => {
    try {
      await updateUserProfileService(unitsPayload(metricImperialToggle));
    } catch (error) {
      logger.error('unit save failed', error);
      return unitsMessage(describeProfileSaveError(error));
    }
    dispatch(handleUnitSelection(metricImperialToggle));
    dispatch(getUserProfileDataService());
    return unitsMessage();
  };

  return {
    panelProps: { metricImperialToggle, setMetricImperialToggle },
    save,
  };
};
